<template>
  <v-navigation-drawer
    color="#0E0A33"
    fixed
    right
    temporary
    width="300"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="hh-spectrum-bar" />

    <v-list
      class="py-6"
      nav
    >
      <v-list-item
        v-for="name in items"
        :key="name"
        :to="{ name }"
        :exact="name === 'Home'"
        active-class="hh-drawer-item--active"
        class="hh-drawer-item"
      >
        <v-list-item-content>
          <v-list-item-title v-text="name" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'HomeDrawer',

    props: {
      items: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>

<style lang="sass">
  .hh-drawer-item
    color: var(--hh-muted) !important

    .v-list-item__title
      font-size: 1.05rem
      font-weight: 500

  .hh-drawer-item--active
    color: var(--hh-cyan) !important

    &::before
      opacity: .08
</style>
